import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar/UserAvatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link/UserLink';
import { PapiDataPackageSellerTopSubscribers } from '@wix/da-papi-types';

import s from './TopSubscribersTableRowHeadingMobile.scss';

interface Props {
  item: NonNullable<
    PapiDataPackageSellerTopSubscribers['timePeriods']['ALL']
  >[number];
  index: number;
}

const TopSubscribersTableRowHeadingMobile: FC<Props> = ({
  item,
  index,
}) => {
  const { t } = useTranslation();
  const { user, deviation, subscriptionStatus } = item;

  if (!user) {
    return null;
  }

  const isActive = subscriptionStatus === 'Active';

  return (
    <Flex direction="row" gap={8}>
      <UserAvatar user={user} size={40} />
      <Flex direction="column" gap={4}>
        <UserLink user={user} className={s['username']} />
        <div className={s['deviation-title']}>{deviation?.title}</div>
        <div className={s[isActive ? 'status-active' : 'status-cancelled']}>
          {t(
            isActive
              ? 'studio.reports.section.topSubscribers.status.active'
              : 'studio.reports.section.topSubscribers.status.cancelled'
          )}
        </div>
      </Flex>
    </Flex>
  );
};

export default TopSubscribersTableRowHeadingMobile;
